import type React from 'react';

// Focus handed back by a closing modal looks "keyboard" to the browser even after a mouse or touch close.
let isKeyboard = false;
if (typeof window !== 'undefined') {
    window.addEventListener('keydown', () => (isKeyboard = true), true);
    window.addEventListener('pointerdown', () => (isKeyboard = false), true);
}

/** onFocus handler: a pointer user gets no focus (and so no ring) back; a keyboard user keeps it. */
export const blurUnlessKeyboard = (event: React.FocusEvent<HTMLElement>) => {
    if (!isKeyboard) event.currentTarget.blur();
};
